import { Routes, Route } from 'react-router-dom'
import Dashboard from '../pages/Dashboard'
import AdminLayout from '../layouts/AdminLayout'
import Login from '../pages/Login'
import Users from '../pages/Users'
import Settings from '../pages/Settings'
import MyAccount from '../pages/UpdatePassword'
import UpdatePassword from '../pages/UpdatePassword'
import Demo from '../pages/Demo'
import Countries from '../pages/Countries'
import Continents from '../pages/Continents'
import Cities from '../pages/Cities'
import PaymentMethods from '../pages/PaymentMethods'
import SubscriptionPlans from '../pages/SubscriptionPlans'
import Suppliers from '../pages/Suppliers'
import Airlines from '../pages/Airlines'
import Airports from '../pages/Airports'
import Services from '../pages/Services'
import FlightServiceFees from '../pages/FlightServiceFees'
import ResponsiveTable from '../pages/ResponsiveTable'
import FlightMarkups from '../pages/FlightMarkups'
import FlightDropnet from '../pages/FlightDropnet'
import StayServiceFees from '../pages/StayServiceFees'
import StayMarkups from '../pages/StayMarkups'
import StayDiscounts from '../pages/StayDiscounts'
import FlightSupplier from '../pages/FlightSupplier'
import StaySuppliers from '../pages/StaySuppliers'
import FlightOfficeID from '../pages/FlightOfficeID'
import Roles from '../pages/Roles'
import UserAccess from '../pages/UserAccess'
import TrackFare from '../pages/TrackFare'
import MIS from '../pages/MIS'
import AirportSearch from '../pages/AirportSearch'
import ItineraryUpdate from '../pages/ItineraryUpdate'
import TransactionList from '../pages/TransactionList'
import HotelItineraryUpdate from '../pages/HotelItineraryUpdate'
import FlightManagement from '../pages/FlightManagement'
import FlightMonitoringSetting from '../pages/FlightMonitoringSetting'
import StayMonitoringSetting from '../pages/StayMonitoringSetting'
import MonitoringTool from '../pages/MonitoringTool'
import LogMonitor from '../pages/LogMonitor'
import ErrorMonitor from '../pages/ErrorMonitor'
import PromotionSetup from '../pages/PromotionSetup'
import PromoGeneration from '../pages/PromoGeneration'
import PromoCode from '../pages/PromoCode'
import FlightDiscount from '../pages/FlightDiscount'
import FlightPromoCodes from '../pages/FlightPromoCodes'
import StayPromoCodes from '../pages/StayPromoCodes'
import StayCommisions from '../pages/StayCommisions'
import AirlinesBlock from '../pages/AirlinesBlock'
import FlightSuppliersMapping from '../pages/FlightSuppliersMapping'
import StaySuppliersMapping from '../pages/StaySuppliersMapping'
import SearchPreferences from '../pages/SearchPreferences'
import Accommodation from '../pages/Accommodation'
import Air from '../pages/Air'
import Emails from '../pages/Emails'
import EmailTemplate from '../pages/EmailTemplate'
import PaymentGateways from '../pages/PaymentGateways'
import Currencies from '../pages/Currencies'
import SuperScreen from '../pages/SuperScreen'
import SuperAdmin from '../pages/SuperAdmin'
import MetaPlan from '../pages/MetaPlan'
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../operations/globalContext";
import { Navigate, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import { isValidJWT } from "../helpers/isValidJWT";
import { jwtDecode, JwtPayload } from "jwt-decode";
import ProtectedRoute from './ProtectedRoute'
import SupplierConfiguration from '../pages/SupplierConfiguration'
import HotelSupplierConfiguration from '../pages/HotelSupplierConfiguration'
import ActivitySupplierConfiguration from '../pages/ActivitySupplierConfiguration'
import ServiceFeeConfiguration from '../pages/ServiceFeeConfiguration'
import SprintDashboard from '../pages/SprintDashboard'
import VendorStatement from '../pages/VendorStatement'
import AirlineBlocking from '../pages/AirlineBlocking'
import ModifyScreen from '../pages/ModifyScreen'
import AirlineCarryOnBaggage from '../pages/AirlineCarryOnBaggage'
import ManualBooking from '../pages/ManualBooking'

interface DecodedToken extends JwtPayload {
  id?: string;
}

const AppRoutes = () => {
    const navigate = useNavigate();
  const { setUserDetails } = useGlobalContext() as any;
  const location = useLocation();

  const { pathname } = location;

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token && isValidJWT(token)) {
      try {
        // Token is already decrypted when stored in localStorage
        const decodedToken = jwtDecode<DecodedToken>(token);
        setUserDetails(decodedToken);
        if (!decodedToken?.id) {
          navigate("/login");
          localStorage.removeItem("jwtToken");
        }
      } catch (error) {
        console.error("Invalid token", error);
      }
    } else {
      localStorage.removeItem("jwtToken");
      if (pathname.startsWith("/resetpassword")) return;
      navigate("/login");
    }
  }, [navigate, setUserDetails, pathname]);

  const isLoggedIn = Boolean(localStorage.getItem("jwtToken"));

    return (
            <Routes>
                <Route path="/login" element={<Login />} />
                {/* <Route path="/resetpassword/:id" element={<ResetPasswordPage />} /> */}
                <Route path="/demo" element={<Demo />} />
                <Route path="/responsive" element={<AdminLayout><ResponsiveTable /></AdminLayout>} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/" element={
                        <AdminLayout>
                            <Dashboard />
                        </AdminLayout>
                    } />
                </Route>
                <Route path="/super-screen" element={<AdminLayout><SuperScreen /></AdminLayout>} />
                <Route path="/modify-screen" element={<AdminLayout><ModifyScreen /></AdminLayout>} />
                <Route path="/vendor-statement" element={<AdminLayout><VendorStatement /></AdminLayout>} />
                <Route path="/airline-blocking" element={<AdminLayout><AirlineBlocking /></AdminLayout>} />
                <Route path="/supplier-configuration" element={<Navigate to="/supplier-configuration/flight" replace />} />
                <Route path="/supplier-configuration/flight" element={<AdminLayout><SupplierConfiguration /></AdminLayout>} />
                <Route path="/supplier-configuration/hotel" element={<AdminLayout><HotelSupplierConfiguration /></AdminLayout>} />
                <Route path="/supplier-configuration/activity" element={<AdminLayout><ActivitySupplierConfiguration /></AdminLayout>} />
                <Route path="/service-fee-configuration" element={<Navigate to="/service-fee-configuration/flight" replace />} />
                <Route path="/service-fee-configuration/:product" element={<AdminLayout><ServiceFeeConfiguration /></AdminLayout>} />
                <Route path="/sprint-dashboard" element={<AdminLayout><SprintDashboard /></AdminLayout>} />
                <Route path="/sprint-dashboard/overview" element={<AdminLayout><SprintDashboard /></AdminLayout>} />
                <Route path="/sprint-dashboard/productivity" element={<AdminLayout><SprintDashboard /></AdminLayout>} />
                <Route path="/sprint-dashboard/command-center" element={<AdminLayout><SprintDashboard /></AdminLayout>} />
                <Route path="/sprint-dashboard/staff" element={<AdminLayout><SprintDashboard /></AdminLayout>} />
                <Route path="/meta-plan" element={<AdminLayout><MetaPlan /></AdminLayout>} />
                <Route path="/super-admin" element={<AdminLayout><SuperAdmin /></AdminLayout>} />
                <Route path="/flight-discount" element={<AdminLayout><FlightDiscount /></AdminLayout>} />
                <Route path="/flight-promo-code" element={<AdminLayout><FlightPromoCodes /></AdminLayout>} />
                <Route path="/stay-promo-codes" element={<AdminLayout><StayPromoCodes /></AdminLayout>} />
                <Route path="/stay-commissions" element={<AdminLayout><StayCommisions /></AdminLayout>} />
                <Route path="/flight-airlines" element={<AdminLayout><AirlinesBlock /></AdminLayout>} />
                <Route path="/flight-mapping" element={<AdminLayout><FlightSuppliersMapping /></AdminLayout>} />
                <Route path="/stay-suppliers-mapping" element={<AdminLayout><StaySuppliersMapping /></AdminLayout>} />
                <Route path="/search-prefereences" element={<AdminLayout><SearchPreferences /></AdminLayout>} />
                <Route path="/accommodation" element={<AdminLayout><Accommodation /></AdminLayout>} />
                <Route path="/air" element={<AdminLayout><Air /></AdminLayout>} />
                <Route path="/emails" element={<AdminLayout><Emails /></AdminLayout>} />
                <Route path="/email-template" element={<AdminLayout><EmailTemplate /></AdminLayout>} />
                <Route path="/payment-gateways" element={<AdminLayout><PaymentGateways /></AdminLayout>} />
                <Route path="/currencies" element={<AdminLayout><Currencies /></AdminLayout>} /> 
                <Route path="/roles" element={<AdminLayout><Roles /></AdminLayout>} />
                <Route path="/users" element={<AdminLayout><Users /></AdminLayout>} />
                <Route path="/roles" element={<AdminLayout><Roles /></AdminLayout>} />
                <Route path="/airport-search" element={<AdminLayout><AirportSearch /></AdminLayout>} />
                <Route path="/user-access" element={<AdminLayout><UserAccess /></AdminLayout>} />
                <Route path="/track-fare" element={<AdminLayout><TrackFare /></AdminLayout>} />
                <Route path="/itinerary-update" element={<AdminLayout><ItineraryUpdate /></AdminLayout>} />
                <Route path="/flight-management" element={<AdminLayout><FlightManagement /></AdminLayout>} />
                <Route path="/hotel-itinerary-update" element={<AdminLayout><HotelItineraryUpdate /></AdminLayout>} />
                <Route path="/transaction-list" element={<AdminLayout><TransactionList /></AdminLayout>} />
                <Route path="/mis" element={<AdminLayout><MIS /></AdminLayout>} />
                <Route path="/monitoring-tool" element={<AdminLayout><MonitoringTool /></AdminLayout>} />
                <Route path="/log-monitor" element={<AdminLayout><LogMonitor /></AdminLayout>} />
                <Route path="/error-monitor" element={<AdminLayout><ErrorMonitor /></AdminLayout>} />
                <Route path="/flight-monitoring-setting" element={<AdminLayout><FlightMonitoringSetting /></AdminLayout>} />
                <Route path="/stay-monitoring-setting" element={<AdminLayout><StayMonitoringSetting /></AdminLayout>} />
                <Route path="/promo-generation" element={<AdminLayout><PromoGeneration /></AdminLayout>} />
                <Route path="/promotion-setup" element={<AdminLayout><PromotionSetup /></AdminLayout>} />
                <Route path="/promo-code" element={<AdminLayout><PromoCode /></AdminLayout>} />
                <Route path="/settings" element={<AdminLayout><Settings /></AdminLayout>} />
                <Route path="/my-account" element={<AdminLayout><MyAccount /></AdminLayout>} />
                <Route path="/update-password" element={<AdminLayout><UpdatePassword /></AdminLayout>} />
                <Route path="/countries" element={<AdminLayout><Countries /></AdminLayout>} />
                <Route path="/continents" element={<AdminLayout><Continents /></AdminLayout>} />
                <Route path="/cities" element={<AdminLayout><Cities /></AdminLayout>} />
                <Route path="/carry-on-baggage" element={<AdminLayout><AirlineCarryOnBaggage /></AdminLayout>} />
                <Route path="/payment-methods" element={<AdminLayout><PaymentMethods /></AdminLayout>} />
                <Route path="/subscription-plans" element={<AdminLayout><SubscriptionPlans /></AdminLayout>} />
                <Route path="/suppliers" element={<AdminLayout><Suppliers /></AdminLayout>} />
                <Route path="/airlines" element={<AdminLayout><Airlines /></AdminLayout>} />
                <Route path="/airports" element={<AdminLayout><Airports /></AdminLayout>} />
                <Route path="/services" element={<AdminLayout><Services /></AdminLayout>} />
                <Route path="/flight-service-fees" element={<AdminLayout><FlightServiceFees /></AdminLayout>} />
                <Route path="/flight-markups" element={<AdminLayout><FlightMarkups /></AdminLayout>} />
                <Route path="/flight-dropnet" element={<AdminLayout><FlightDropnet /></AdminLayout>} />
                <Route path="/stay-service-fees" element={<AdminLayout><StayServiceFees /></AdminLayout>} />
                <Route path="/stay-markups" element={<AdminLayout><StayMarkups /></AdminLayout>} />
                <Route path="/stay-discounts" element={<AdminLayout><StayDiscounts /></AdminLayout>} />
                <Route path="/flight-supplier" element={<AdminLayout><FlightSupplier /></AdminLayout>} />
                <Route path="/stay-suppliers" element={<AdminLayout><StaySuppliers /></AdminLayout>} />
                <Route path="/flight-office" element={<AdminLayout><FlightOfficeID /></AdminLayout>} />
                <Route path="/manual-booking" element={<Navigate to="/manual-booking/flight" replace />} />
                <Route path="/manual-booking/:type" element={<AdminLayout><ManualBooking /></AdminLayout>} />
            </Routes>
    )
}

export default AppRoutes